var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDotMenu = function SvgDotMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#22354F",
    d: "M12.569 7.143q-.57.015-1.14 0c-.77-.04-1.51-.77-1.54-1.54q-.015-.57 0-1.14c.04-.77.77-1.51 1.54-1.54q.57-.015 1.14 0c.77.04 1.51.77 1.54 1.54q.015.57 0 1.14c-.04.77-.77 1.51-1.54 1.54M12.571 14.11q-.57.015-1.14 0c-.77-.04-1.51-.77-1.54-1.54q-.015-.57 0-1.14c.04-.77.77-1.51 1.54-1.54q.57-.015 1.14 0c.77.04 1.51.77 1.54 1.54q.015.57 0 1.14c-.04.77-.77 1.51-1.54 1.54M12.569 21.076q-.57.015-1.14 0c-.77-.04-1.51-.77-1.54-1.54q-.015-.57 0-1.14c.04-.77.77-1.51 1.54-1.54q.57-.015 1.14 0c.77.04 1.51.77 1.54 1.54q.015.57 0 1.14c-.04.77-.77 1.51-1.54 1.54"
  })));
};
export default SvgDotMenu;